import styled from 'styled-components';
import { RadioButton } from '../RadioButton';

export const Container = styled.div`
  background: ${(props) => props.theme.colors.activeMenuBackgroundColor};
  border: 0.3px solid ${(props) => props.theme.colors.diviserSmoothColor};
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
`;

export const Head = styled.div`
  color: #610082;
  padding: 3px;
  margin: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.diviserColor};

  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
  width: ${(props) => `${props.headWidth}px`};
`;

export const InnerContainer = styled.div`
  margin: 10px 10px 10px 10px
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
`;

export const Radio = styled(RadioButton)`
  color: #11ada0;
  padding: 3px;
  width: 100px;
  text-transform: uppercase;

  .radio-button-control {
    margin-right: 3px;
  }

  .radio-button-control {
    border: 1px solid #11ada0;
  }

  .radio-button-input:checked+.radio-button-control:after {
    background-color: #11ada0;
  }

  &.inactive {
    color: #F08282;
    .radio-button-control {
      border: 1px solid #F08282;
    }
    .radio-button-input:checked+.radio-button-control:after {
      background-color: #F08282;
    }
  }
`;

export const Clicable = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: calc(100% / 3);

  &>button {
    width: 100%;
  }
`;
